import { ChevronRight } from 'lucide-react';

import { DimeButton } from '../DimeButton.js';
import { cn } from '../lib/utils.js';

/** The bordered chevron that opens or folds a row group; it doesn't also fire the header row's click. */
export function RowGroupToggle({
  expanded,
  label,
  onToggle,
}: Readonly<{ expanded: boolean; label: string; onToggle: () => void }>) {
  return (
    <DimeButton
      type="button"
      variant="outline"
      size="icon-sm"
      aria-expanded={expanded}
      aria-label={label}
      onClick={(event) => {
        event.stopPropagation();
        onToggle();
      }}
    >
      <ChevronRight
        aria-hidden
        className={cn('size-4 transition-transform', expanded && 'rotate-90')}
      />
    </DimeButton>
  );
}
